export default __webpack_public_path__ + "static/media/b-4.0e3f6b87.svg";